<template>
  <div class="header-wrapper">
    <header class="head">
      <h1 class="logo-wrapper">
        <a href="/">
          <img src="./logo.png" alt="logo" width="180" height="40">
        </a>
      </h1>
      <div class="search-wrapper">
        <div class="search">
          <input type="text"
                 v-model="searchText"
                 placeholder="搜索课程"
                 class="search-input"
                 @keydown="searchKeyWord($event)">
          <span class="search-btn" @click="searchToo">搜索</span>
        </div>
      </div>
      <section class="head-right">
        <section class="page-link-wrapper">
          <span class="page-link"><router-link to="/account">我的学习</router-link></span>
          <span class="page-link" v-if="consoleShow"><router-link to="/console">老师管理后台</router-link></span>
        </section>
        <section class="unlogin" v-if="id==false">
          <span class="text link"><a>登录</a></span>
          <span class="text">/</span>
          <span class="text link"><router-link to="/register">注册</router-link></span>
          <span class="face-wrapper">
            <img src="./avatar.jpg" alt="头像" width="28" height="28">
          </span>
        </section>
        <section class="logged" v-else>
          <span class="text">{{decodeURIComponent(userinfo.uname)}}</span>
          <span class="face-wrapper">
            <img src="./avatar.jpg" alt="头像" width="28" height="28">
          </span>
          <ul class="second-ul">
            <li class="second-li" @click="showChangeUserinfo">个人资料</li>
            <li class="second-li" @click="clearOut">退出当前账号</li>
          </ul>
        </section>
      </section>
    </header>
    <div class="lessonpop-mask" v-if="userinfoShow">
      <div class="lessonpop">
        <h2 class="title">个人资料</h2>
        <p class="row">
          <span class="left">用户名：</span>
          <input type="text" class="input-name" v-model="uname" placeholder="请填写用户名" maxlength="10">
        </p>
        <p class="row">
          <span class="left">性别：</span>
          <select name="sex" class="type-select" v-model="sex">
            <option disabled selected value="">请选择</option>
            <option value="男" selected>男</option>
            <option value="女">女</option>
          </select>
        </p>
        <div class="cover-row">
          <span class="left">用户头像：</span>
          <span class="right">
            <span class="img-wrapper">
              <img class="img" :src="imgurl" alt="cover" width="100" height="100">
            </span>
            <div class="upload-button-wrapper">
              <vue-core-image-upload
                class="upload-button"
                crop="local"
                text="选择本地图片"
                :cropBtn="{ok:'确定','cancel':'取消'}"
                cropRatio="1:1"
                @imageuploaded="imageuploaded"
                :max-file-size="5242880"
                :url="imgUpUrl">
                </vue-core-image-upload>
              <span class="hint">建议上传480*480的图片，大小不超过5M</span>
            </div>
          </span>
        </div>
        <div class="operate-btn-wrapper">
          <button class="btn cancel" @click="userinfoShow=false">取消</button>
          <button class="btn confirm" @click="updateUser">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import VueCoreImageUpload from 'vue-core-image-upload';
  export default{
    data(){
      return {
        id: (() => loadLocal('id', false))(),
        userinfo: (() => loadLocal('userinfo', false))(),
        searchText: '',
        myurl: '',
        consoleShow: false,
        //---------------以下内容和修改用户信息有关--------------
        userinfoShow: false,
        uname: '',                      //用户名
        sex: '',                       //用户的性别
        imgUpUrl: '',              //该url是组件‘vue-core-image-upload’上传的url地址（带sessionid）
        imgurl: require('./cover.png'),
        upurl: '',                //不包含imgprefix,上传的图片url

      }
    },
    methods: {
      searchKeyWord(event){
        if (event.keyCode == "13") {
          let inputValue = this.searchText;
          inputValue = inputValue.trim();
          if (inputValue !== '') {
            window.location.href = '/study/search?keyword=' + inputValue + '&pageno=1';
          }
        }
      },
      searchToo(){
        let inputValue = this.searchText;
        inputValue = inputValue.trim();
        if (inputValue !== '') {
          window.location.href = '/study/search?keyword=' + inputValue + '&pageno=1';
        }
      },
      clearOut(){
        this.id = false;
        window.localStorage.clear();
        window.sessionStorage.clear();
        window.location.href = '/';
        this.$forceUpdate();
      },
      //用户点击更改用户信息
      showChangeUserinfo(){
        this.uname = decodeURIComponent(this.userinfo.uname);
        this.sex = decodeURIComponent(this.userinfo.sex);
        if (this.userinfo.headimg !== '') {
          this.imgurl = this.userinfo.headimgpath + decodeURIComponent(this.userinfo.headimg);
          this.upurl = decodeURIComponent(this.userinfo.headimg);
        }
        this.userinfoShow = true;
      },
      //VueCoreImageUpload上传后调用的方法
      imageuploaded(response) {
        if (response.code === 111) {
          this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
        } else if (response.code === 200) {
          this.imgurl = response.imgprefix + response.image;
          this.upurl = response.image;
        }
      },
      //更新用户信息
      updateUser(){
        let params = {
          c: 'User',
          a: 'updateuser',
          id: this.id,
          uname: this.uname,
          sex: this.sex,
        };
        if (this.upurl != '') {
          params.headimg = this.upurl;
        }
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: params
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.queryUserInfo();
            this.$message({
              message: '更新信息成功',
              type: 'success'
            });
            this.userinfoShow = false;
          }
        }).catch((err) => {
          this.$alert('请求失败，请重试', '提示', {
            confirmButtonText: '确定',
          });
        })
      },
      queryUserInfo(){
        //接口：查询班级课程目录列表
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'user',
            a: 'userinfo',
            id: this.id,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            saveLocal('userinfo', response);
            this.userinfo = response;
          }
        }).catch((err) => {
          this.queryUserInfo();
        })
      }
    },
    created(){
      //裁切图片上传的地址
      this.imgUpUrl = `${this.GLOBAL.uploadUrl}indexapp.php?c=Upload&a=UploadFileVue&id=` + this.id;
      //获取当前的网页前缀
      //window.location是object对象格式
      let start = String(window.location).indexOf('#') + 1;
      this.myurl = String(window.location).substring(start);

      //根据userinfo获取用户是否为老师
      if (this.userinfo.identity === 1) {
        this.consoleShow = true;
      }
    },
    components: {
      VueCoreImageUpload,
    }

  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .header-wrapper
    position fixed
    top: 0
    left: 0
    width: 100%
    height: 60px
    background #fff
    border-bottom: 1px solid #efefef
    box-shadow: 0 0 10px 2px #fafafa
    z-index: 100
    .head
      margin: 0 auto
      width: 1000px
      /*font-size: 0*/
      .logo-wrapper
        float: left
        margin-right: 40px
        padding-top: 10px
        display: inline-block
        width: 180px
        height: 40px
        cursor: pointer
      .search-wrapper
        float: left
        height: 48px
        padding-top: 12px
        .search
          width: 300px;
          height: 36px;
          border-radius: 4px;
          box-sizing: border-box;
          overflow: hidden;
          .search-input
            width: 220px;
            height: 36px;
            line-height: 36px;
            padding-left: 10px;
            box-sizing: border-box;
            font-size: 14px;
            color: #000;
            background: #f2f2f2;
            border-radius: 4px;
            &::-webkit-input-placeholder
              color: #999;
          .search-btn
            float: right;
            display: inline-block;
            height: 36px;
            line-height: 36px;
            width: 80px;
            background: #3399ff;
            font-size: 16px;
            text-align: center;
            color: #ffffff;
            cursor: pointer;
      .head-right
        float: right
        height: 60px
        .page-link-wrapper
          float: left
          .page-link
            height: 60px
            line-height: 60px
            margin-right: 20px
            font-size: 14px
            color: #333
            cursor: pointer
            a
              color: #333
            &:hover a
              color: #3399ff
            &:last-child
              position: relative;
              padding-right: 22px;
              &::before
                content: ' ';
                position: absolute;
                top: 2px;
                right: 0;
                display: inline-block;
                width: 2px;
                height: 16px;
                background: #ccc;
        .unlogin, .logged
          float: right;
          height: 60px;
          cursor: pointer;
          .text
            display: inline-block
            height: 60px
            line-height: 60px
            font-size: 14px
            color: #333
            vertical-align: top
            &.link a
              color: #333
            &.link:hover a
              color: #3399ff
          .face-wrapper
            margin-left: 5px
            position: relative;
            top: 16px;
            font-size: 0;
            display: inline-block;
            width: 28px;
            height: 28px;
            border-radius: 14px;
            overflow: hidden;
        .logged
          position: relative
          &:hover .second-ul
            display block
          .second-ul
            display none
            position absolute
            top: 100%
            right: 0
            z-index: 100
            background #fff
            .second-li
              width: 100px
              height: 40px
              line-height: 40px
              text-align: center
              font-size: 14px
              color: #666666
              border: 1px solid #e4e4e4
              &:hover
                color: #3399ff
    .lessonpop-mask
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      z-index: 1000
      overflow: auto
      .lessonpop
        margin: auto
        width: 555px
        padding: 30px 60px 40px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        .title
          padding: 0 0 45px
          line-height: 40px
          font-size: 24px
          color: #000
          font-weight: bold
        .row
          margin-bottom: 10px
          height: 35px
          .left
            display: inline-block
            margin-right: 10px
            line-height: 35px
            width: 75px
            font-size: 15px
            color: #888
          .input-name
            width: 250px
            height: 35px
            font-size: 15px
            color: #000
            padding-left: 6px
            border: 1px solid #d7d7d7
            border-radius: 4px
            box-sizing: border-box
            &::-webkit-input-placeholder
              color: #ccc
          .type-select
            width: 105px
            font-size: 14px
            color: #000
            border: 1px solid #e4e4e4
            height: 35px
            -webkit-appearance: none
            -moz-appearance: none
            appearance: none
            background: #fff url('down.png') no-repeat right 9px center
            background-size: 12px 12px
            padding: 0 30px 0 6px
            border-radius: 4px
            box-sizing: border-box
        .cover-row
          margin-bottom: 12px
          height: 140px
          .left
            display: inline-block
            margin-right: 10px
            width: 75px
            height: 100%
            line-height: 100px
            font-size: 15px
            color: #888
            vertical-align: top
          .right
            display: inline-block
            .img
              vertical-align: top
            .upload-button-wrapper
              height: 30px
              margin-top: 10px
              padding-left: 10px
              .upload-button
                display: inline-block
                margin-right: 10px
                height: 30px
                line-height: 30px
                width: 90px
                text-align: center
                background: #f2f2f2
                color: #666
                font-size: 13px
                border: 1px solid #d7d7d7
                border-radius: 4px
                box-sizing border-box
                vertical-align: top
                cursor: pointer
              .hint
                display: inline-block
                width: 235px
                height: 28px
                line-height: 28px
                text-align: center
                font-size: 12px
                color: #999999
                border-radius: 4px
                border: 1px solid #ffb76e
                background: #fff9e7

        .operate-btn-wrapper
          margin: 40px auto 0
          width: 225px
          .btn
            width: 80px
            height: 34px
            line-height: 34px
            font-size: 16px
            color: #ffffff
            border-radius 4px
          .cancel
            margin-right: 65px
            background #ccc
          .confirm
            background #3399ff
</style>



// WEBPACK FOOTER //
// src/components/globalnav/GlobalNav.vue